/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-03-04",
    versionChannel: "nightly",
    buildDate: "2024-03-04T00:06:04.544Z",
    commitHash: "85dd25816893c80df8f1220301a0d3e97719aec4",
};
